import React from 'react'
import { AppProps } from 'next/app'

import ErrorBoundary from '@/components/ErrorBoundary'

import '@/styles/globals.css'

if (process.env.NEXT_PUBLIC_API_MOCKING === 'enabled') {
  import('../../mocks')
}

const MyApp: React.FC<AppProps> = ({ Component, pageProps }) => {
  return (
    <ErrorBoundary correlationId={pageProps.correlationId}>
      <Component {...pageProps} />
    </ErrorBoundary>
  )
}

export default MyApp
